import { formatReward } from "./instant-data";
import PencilIcon from "./pencil-icon";
import PrimaryButton from "./primary-button";

export default function ConfirmAddress({ address, amount, onBack, onEdit, onConfirm, isSubmitting }) {
  return (
    <section className="ir-sheet">
      <div className="ir-sheet-top">
        <button className="ir-icon-btn is-ghost" type="button" aria-label="Go back" onClick={onBack}>
          <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true">
            <path d="M10 3.5 5.5 8 10 12.5" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
      </div>
      <div className="ir-sheet-body">
        <div>
          <h1>Confirm your mailing address</h1>
          <p className="ir-sheet-lead">
            Since your application wasn’t approved, we’ll mail your Move-In Cash as a check once your property approves it.
            Make sure you can receive mail at this address.
          </p>
        </div>
        <div className="ir-sheet-blocks">
          <div className="ir-address-card">
            <div className="ir-address-top">
              <span>Mailing address</span>
              <button type="button" onClick={onEdit}>
                <PencilIcon color="#54ff99" />
                Edit
              </button>
            </div>
            <strong>{address.name || "Your name"}</strong>
            {address.lines.map((line) => (
              <span key={line}>{line}</span>
            ))}
          </div>
          <div className="ir-meta-row">
            <div>
              <span>Amount</span>
              <strong>{formatReward(amount, { cents: true }) || "—"}</strong>
            </div>
            <div>
              <span>Delivery</span>
              <strong>Physical check</strong>
            </div>
            <div>
              <span>Est. arrival</span>
              <strong>2–4 months</strong>
            </div>
          </div>
        </div>
      </div>
      <div className="ir-sheet-footer">
        <PrimaryButton onClick={onConfirm} disabled={isSubmitting}>
          {isSubmitting ? "Confirming…" : "Confirm"}
        </PrimaryButton>
      </div>
    </section>
  );
}
